import React from "react";

export default function VideoIQSection() {
  return (
    <section className="flex flex-col md:flex-row items-center justify-between max-w-4xl mx-auto gap-10">
      <div className="flex flex-col self-start md:self-auto">
        <div className="font-bebas font-normal tracking-wider text-[30px]  lg:text-[50px] leading-[130%] text-[#06382f] mb-6">
          <span className="text-[#0E8A43]">VideoIQ</span> — <br />
          <span>Real Engagement.</span>
        </div>

        <ul className="text-[#004D4D] text-base lg:text-lg font-inter font-medium leading-[130%] space-y-6 pl-5 list-disc mb-6">
          <li>Licensed, YouTube and Social Videos. All in One.</li>
          <li>Highly Interactive, Branded Layout</li>
          <li>10+ verticals: News, Lifestyle, Sports, Business, etc.</li>
        </ul>

        <div className="text-[#004D4D] text-lg md:text-[20px] font-medium font-inter">
          Not just autoplay — it’s video that’s actually watched.
        </div>
      </div>

      <div className="w-full max-w-[350px]">
        <video
          src="./videoIQ.mov"
          controls
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-auto object-cover"
        />
      </div>
    </section>
  );
}
